<template>
  <div class="cooperation">
    <div class="cooperation-container">
      <div class="title">
        <p>Cooperation advantage</p>
        <h2>合作优势</h2>
      </div>
      <div class="info">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
            <div class="info">
              <img src="@/assets/images/img1.7.png" class="img">
              <p>成功后收费 </p>
              <p>有保障</p>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" :offset="1">
            <div class="info">
              <img src="@/assets/images/img1.8.png" class="img">
              <p class="violet">不成功 </p>
              <p class="violet">可获赔偿</p>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" :offset="1">
            <div class="info">
              <img src="@/assets/images/img1.9.png" class="img">
              <p>全程服务 </p>
              <p>全程跟踪</p>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" :offset="1">
            <div class="info">
              <img src="@/assets/images/img1.10.png" class="img">
              <p class="violet">专业财务 </p>
              <p class="violet">规范规划</p>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" :offset="1">
            <div class="info">
              <img src="@/assets/images/11.png" class="img">
              <p>免费代写 </p>
              <p>技术方案</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cooperation"
};
</script>

<style lang="scss" scoped>
.cooperation {
  background-color: #f9faff;
  .cooperation-container {
    width: 1000px;
    margin: 0 auto;
    padding: 30px;
    text-align: center;
    .title {
      p {
        color: #f7a527;
        text-transform: uppercase;
        letter-spacing: 2px;
        word-spacing: 10px;
        font-size: 12px;
        line-height: 20px;
      }
      h2 {
        color: #666666;
        letter-spacing: 10px;
        margin-top: 10px;
      }
    }
    .info{
        padding:30px 0 20px;
        .img{
            width: 56%;
            margin-bottom:15px;
        }
        p{
            color:#f7a527;
        }
        .violet{
            color:#2F32A8;
        }
    }
  }
}
@media screen and (max-width: 768px) {
  .cooperation {
  .cooperation-container {
    width: 100%;
    padding: 30px 0px;
    .info{
        padding:30px 10px 10px;
        .el-col-offset-1{margin:0;}
    }
  }
}
}
</style>






// WEBPACK FOOTER //
// src/components/technology/cooperation.vue